import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SPOILER_TYPE } from '../types.js';
import { InlineToolbarButton, FORMATTING_BUTTONS, RichUtils } from 'wix-rich-content-editor-common';
import { SpoilerButtonIcon } from 'wix-rich-content-plugin-commons';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TextSpoilerButton extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "handleClick", (event) => {
      event.preventDefault();
      const { isActive } = this.state;
      const { getEditorState, setEditorState } = this.props;
      setEditorState(RichUtils.toggleInlineStyle(getEditorState(), SPOILER_TYPE));
      this.setState({ isActive: !isActive });
    });
    __publicField(this, "isActive", () => {
      const { getEditorState } = this.props;
      if (getEditorState) {
        return getEditorState().getCurrentInlineStyle().has(SPOILER_TYPE);
      } else {
        return false;
      }
    });
    this.state = { isActive: false };
  }
  componentWillReceiveProps() {
    this.setState({ isActive: this.isActive() });
  }
  render() {
    const { theme, helpers, isMobile, tabIndex, t, disabled } = this.props;
    const { isActive } = this.state;
    return /* @__PURE__ */ React.createElement(
      InlineToolbarButton,
      {
        onClick: this.handleClick,
        helpers,
        theme,
        isMobile,
        tooltipText: t("Spoiler_Insert_Tooltip"),
        dataHook: "textSpoilerButton",
        formattingButtonName: FORMATTING_BUTTONS.SPOILER,
        tabIndex,
        icon: SpoilerButtonIcon,
        isActive,
        pluginType: SPOILER_TYPE,
        disabled
      }
    );
  }
}
TextSpoilerButton.propTypes = {
  getEditorState: PropTypes.func.isRequired,
  setEditorState: PropTypes.func.isRequired,
  theme: PropTypes.object,
  helpers: PropTypes.object,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
  tabIndex: PropTypes.number,
  config: PropTypes.object,
  adjustment: PropTypes.number,
  tooltipKey: PropTypes.string,
  dataHook: PropTypes.string,
  icon: PropTypes.object,
  disabled: PropTypes.bool
};

export { TextSpoilerButton as default };
//# sourceMappingURL=TextSpoilerButton.js.map
